import { ActivityGroupResponse } from '../../../../api/core/models/api/activity-group-response';
import { ACTIVITY_DEFINITION_SECTOR_MAP_REVERSE } from './emission-sector-map';
import { ACTIVITY_DEFINITION_SECTOR_MAP_REVERSE_COP_PANORAMA } from './emission-sector-map.cop-panorama';

export const getColourFromActivityGroupCopPanorama = (activityGroup: ActivityGroupResponse): string => {
  return (
    ACTIVITY_DEFINITION_SECTOR_MAP_REVERSE_COP_PANORAMA?.[
      activityGroup?.children?.[0]?.activityDefinitions?.[0] ?? ''
    ] ?? 'grey'
  );
};

export const getColourFromActivityGroup = (activityGroup: ActivityGroupResponse): string => {
  const getFirstActivity = (group: ActivityGroupResponse): string | undefined => {
    if (group.activityDefinitions?.length) {
      return group.activityDefinitions[0];
    }

    if (group.children?.length) {
      for (const child of group.children) {
        const activity = getFirstActivity(child);
        if (activity) {
          return activity;
        }
      }
    }
    return undefined;
  };

  return ACTIVITY_DEFINITION_SECTOR_MAP_REVERSE?.[getFirstActivity(activityGroup) ?? ''] ?? 'grey';
};
